import { Expose } from "class-transformer";

export class CreateBusinessLineDto {
  @Expose()
  code: string;

  @Expose()
  name: string;
}
